/* eslint-disable camelcase */
import api from '@pray/shared/utils/api';

export type WorkflowMetricsCampaign = {
  campaign_id: string;
  campaign_name: string;
  sent: number;
  delivered: number;
  opened: number;
  clicked: number;
  spam_reports: number;
  unsubscribes: number;
  open_rate: number;
  click_rate: number;
  spam_rate: number;
};

export type WorkflowMetricsFunnelNode = {
  node_id: string;
  node_type: string;
  execution_order: number;
  completed_count: number;
  current_count: number;
  currently_waiting: number;
};

export type WorkflowMetricsFunnel = {
  total_entered: number;
  total_completed: number;
  currently_active: number;
  nodes: WorkflowMetricsFunnelNode[];
};

export type WorkflowMetricsPushCampaign = {
  node_id: string;
  push_title: string;
  sent: number;
  failed: number;
  skipped: number;
  rate_limited: number;
};

export type WorkflowMetricsData = {
  workflow_automation_id: string;
  total_sent: number;
  total_delivered: number;
  overall_open_rate: number;
  overall_click_rate: number;
  overall_spam_rate: number;
  total_unsubscribes: number;
  funnel: WorkflowMetricsFunnel;
  campaigns: WorkflowMetricsCampaign[];
  push_campaigns?: WorkflowMetricsPushCampaign[];
};

export type WorkflowMetricsResponse = {
  data: WorkflowMetricsData;
};

type GetMetricsProps = {
  artistId: string;
  workflowId: string;
  versionNumber: number;
};

export async function getMetrics({
  artistId,
  workflowId,
  versionNumber,
}: GetMetricsProps): Promise<WorkflowMetricsResponse> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!workflowId) throw new Error('Workflow ID is required');
  if (versionNumber === undefined || versionNumber === null) throw new Error('Version number is required');

  const url = `/web/studio/artists/${artistId}/workflows/${workflowId}/versions/${versionNumber}/metrics`;

  const response = await api.executeGetRequest<WorkflowMetricsResponse>(url);
  return response.data;
}
